import Vue from 'vue'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  baseURL: `/api`,
  headers: {
    Accept: 'application/json',
    'x-user-type': 'ADMIN',
  },
})

const axiosInsBase = axios.create({
  baseURL: `/`,
  headers: {
    Accept: 'application/json',
    'x-user-type': 'ADMIN',
  },
})

// const axiosInsUserProfile = axios.create({
//   baseURL: '/user',
//   headers: {
//     Accept: 'application/json',
//     'x-user-type': 'ADMIN',
//   },
// })

// const axiosInsDeduction = axios.create({
//   baseURL: '/employee-deduction',
//   headers: {
//     Accept: 'application/json',
//     'x-user-type': 'ADMIN',
//   },
// })

// const axiosInsUiComponent = axios.create({
//   baseURL: '/uicomponent',
//   headers: {
//     Accept: 'application/json',
//     'x-user-type': 'ADMIN',
//   },
// })

Vue.prototype.$http = axiosIns
Vue.prototype.$httpBase = axiosInsBase
// Vue.prototype.$httpUserProfile = axiosInsUserProfile
// Vue.prototype.$httpDeduction = axiosInsDeduction
// Vue.prototype.$httpMenu = axiosInsUiComponent

export default axiosIns
